import axios from "axios";
import Cookies from "js-cookie";
import { config } from "@/configs/config";

export const baseURL = config.base_url_uz;

export const axiosInstanceSend = axios.create({
  baseURL: config.send_parcel_url_ge,
});

axiosInstanceSend.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error?.response && error?.response?.status === 401) {
      Cookies.remove("sendToken");
      window.location.href = "/log-in";
    }
    return Promise.reject(error);
  },
);
